/* ============================================
   LELUXE24 — THEME JS 2026
   ============================================ */

document.addEventListener('DOMContentLoaded', function () {

  // ============================================
  // HEADER SCROLL EFFECT
  // ============================================
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 40);
    }, { passive: true });
  }

  // ============================================
  // MOBILE MENU
  // ============================================
  const hamburger = document.querySelector('.header__hamburger');
  const mobileMenu = document.querySelector('.mobile-menu');
  const mobileClose = document.querySelector('.mobile-menu__close');

  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', () => {
      mobileMenu.classList.add('open');
      document.body.style.overflow = 'hidden';
    });
  }

  if (mobileClose && mobileMenu) {
    mobileClose.addEventListener('click', () => {
      mobileMenu.classList.remove('open');
      document.body.style.overflow = '';
    });
  }

  // ============================================
  // FAQ ACCORDION
  // ============================================
  document.querySelectorAll('.faq-item__question').forEach(question => {
    question.addEventListener('click', function () {
      const item = this.closest('.faq-item');
      const isOpen = item.classList.contains('open');

      // Close all
      document.querySelectorAll('.faq-item').forEach(i => i.classList.remove('open'));

      // Open clicked (unless was open)
      if (!isOpen) item.classList.add('open');
    });
  });

  // ============================================
  // PRODUCT GALLERY THUMBS
  // ============================================
  document.querySelectorAll('.product-gallery__thumb').forEach(thumb => {
    thumb.addEventListener('click', function () {
      const gallery = this.closest('.product-gallery');
      const main = gallery.querySelector('.product-gallery__main img');
      const src = this.querySelector('img')?.src;

      document.querySelectorAll('.product-gallery__thumb').forEach(t => t.classList.remove('active'));
      this.classList.add('active');

      if (main && src) {
        main.style.opacity = '0';
        setTimeout(() => {
          main.src = src;
          main.style.opacity = '1';
          main.style.transition = 'opacity 0.3s ease';
        }, 150);
      }
    });
  });

  // ============================================
  // COUNTDOWN TIMER
  // ============================================
  function initCountdown() {
    const timers = document.querySelectorAll('[data-countdown]');
    timers.forEach(timer => {
      let hours = parseInt(timer.dataset.hours || 2);
      let minutes = parseInt(timer.dataset.minutes || 47);
      let seconds = parseInt(timer.dataset.seconds || 33);

      function update() {
        seconds--;
        if (seconds < 0) { seconds = 59; minutes--; }
        if (minutes < 0) { minutes = 59; hours--; }
        if (hours < 0) { hours = 0; minutes = 0; seconds = 0; }

        const h = timer.querySelector('[data-hours]');
        const m = timer.querySelector('[data-minutes]');
        const s = timer.querySelector('[data-seconds]');
        if (h) h.textContent = String(hours).padStart(2, '0');
        if (m) m.textContent = String(minutes).padStart(2, '0');
        if (s) s.textContent = String(seconds).padStart(2, '0');
      }

      setInterval(update, 1000);
      update();
    });
  }
  initCountdown();

  // ============================================
  // LIVE PURCHASE NOTIFICATION
  // ============================================
  const purchases = [
    { name: 'Sarah M.', location: 'München', product: 'LumiWake™ Lichtwecker', time: 'vor 3 Min.' },
    { name: 'Kevin B.', location: 'Berlin', product: 'Push-Up Board Set', time: 'vor 7 Min.' },
    { name: 'Lena K.', location: 'Hamburg', product: 'Elektro-Entsafter', time: 'vor 12 Min.' },
    { name: 'Thomas W.', location: 'Köln', product: 'Fahrradhelm 4-in-1', time: 'vor 2 Min.' },
    { name: 'Mia S.', location: 'Frankfurt', product: 'Pilates Ring', time: 'vor 5 Min.' },
  ];

  const notification = document.querySelector('.live-notification');
  if (notification) {
    let idx = 0;
    function showNotification() {
      const p = purchases[idx % purchases.length];
      idx++;

      notification.querySelector('.live-notification__text strong').textContent =
        `${p.name} aus ${p.location}`;
      notification.querySelector('.live-notification__text span').textContent =
        `hat gerade "${p.product}" gekauft`;
      notification.querySelector('.live-notification__time').textContent = p.time;

      notification.classList.add('show');

      setTimeout(() => notification.classList.remove('show'), 4000);
    }

    // First notification after 5s, then every 15s
    setTimeout(() => { showNotification(); setInterval(showNotification, 15000); }, 5000);
  }

  // ============================================
  // SCROLL REVEAL ANIMATIONS
  // ============================================
  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('revealed');
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  document.querySelectorAll('.reveal').forEach(el => observer.observe(el));

  // ============================================
  // STICKY ADD TO CART (Product Page)
  // ============================================
  const productHero = document.querySelector('.product-hero');
  const stickyBar = document.querySelector('.sticky-atc');

  if (productHero && stickyBar) {
    const heroObserver = new IntersectionObserver(
      ([entry]) => stickyBar.classList.toggle('visible', !entry.isIntersecting),
      { threshold: 0 }
    );
    heroObserver.observe(productHero);
  }

  // ============================================
  // ADD TO CART — AJAX
  // ============================================
  document.querySelectorAll('[data-add-to-cart]').forEach(btn => {
    btn.addEventListener('click', async function (e) {
      e.preventDefault();
      const variantId = this.dataset.variantId;
      if (!variantId) return;

      const original = btn.innerHTML;
      btn.innerHTML = '✓ Hinzugefügt!';
      btn.style.background = '#27ae60';

      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });

        // Update cart count
        const res = await fetch('/cart.js');
        const cart = await res.json();
        const countEl = document.querySelector('.header__cart-count');
        if (countEl) countEl.textContent = cart.item_count;

      } catch (err) {
        console.error(err);
      }

      setTimeout(() => {
        btn.innerHTML = original;
        btn.style.background = '';
      }, 2500);
    });
  });

  // ============================================
  // SMOOTH SECTION ENTRANCE
  // ============================================
  const style = document.createElement('style');
  style.textContent = `
    .reveal { opacity: 0; transform: translateY(24px); transition: opacity 0.7s ease, transform 0.7s ease; }
    .reveal.revealed { opacity: 1; transform: translateY(0); }
    .reveal-delay-1 { transition-delay: 0.1s; }
    .reveal-delay-2 { transition-delay: 0.2s; }
    .reveal-delay-3 { transition-delay: 0.3s; }
    .reveal-delay-4 { transition-delay: 0.4s; }
    .sticky-atc { position:fixed; bottom:0; left:0; right:0; z-index:90; background:var(--white); border-top:1px solid var(--gray-200); padding:12px var(--spacing-md); transform:translateY(100%); transition:transform 0.3s ease; box-shadow:0 -4px 24px rgba(0,0,0,0.1); }
    .sticky-atc.visible { transform:translateY(0); }
    .sticky-atc__inner { max-width:600px; margin:0 auto; display:flex; align-items:center; justify-content:space-between; gap:var(--spacing-sm); }
    .sticky-atc__title { font-family:var(--font-display); font-size:18px; font-weight:400; }
    .sticky-atc__price { font-size:20px; font-weight:600; }
    .product-gallery__main img { transition: opacity 0.3s ease; }
  `;
  document.head.appendChild(style);

});
